import {
    AlignLeft, Calendar, CalendarClock, CheckSquare, Globe, Hash, Info, ListChecks, Paperclip, Type, User, ToggleLeft,
    type LucideIcon,
} from 'lucide-react'
import type { FieldType } from '../../types'

export const TYPE_ICON: Record<FieldType, LucideIcon> = {
    text: Type,
    textarea: AlignLeft,
    number: Hash,
    yes_no: ToggleLeft,
    single_select: CheckSquare,
    multi_select: ListChecks,
    date: Calendar,
    datetime: CalendarClock,
    file: Paperclip,
    user_reference: User,
    country: Globe,
    html: Info,
}
